module.exports = __webpack_public_path__ + "img/slide-1.8332fd26.png";